import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { FaArrowRight } from "react-icons/fa6";
import { IoReload } from "react-icons/io5";
import { useOrganization } from '../../../../hooks/useOrganization';
import sparkle from '../../../../assets/sparkle.svg';
import reload from '../../../../assets/reload.svg';
interface SuggestionsProps {
    onSelect: (suggestion: string) => void;
}

const Suggestions: React.FC<SuggestionsProps> = ({ onSelect }) => {
    
    // State for current suggestions
    const [suggestions, setSuggestions] = useState()

    const { organization, isLoading, error } = useOrganization();



    // Handle re-roll
    const handleReroll = () => {
        // setSuggestions(getRandomSuggestions(allSuggestions, 3));
    };

    return (
        <div className="flex flex-col w-full justify-center">
            <div className="flex flex-col gap-2">
                {organization?.initial_intent_signals?.map((signal, index) => (
                    <div 
                        key={index} 
                        className="flex items-center justify-between px-4 py-[10px] h-[40px] bg-[#FFFFFF] rounded-[10px] border border-[#DDDDDD] hover:bg-[#F7F7F7] cursor-pointer"
                        onClick={() => onSelect(signal)}
                    >
                        <div className="flex items-start gap-2 flex-1">
                            <img src={sparkle} alt="sparkle" className="w-4 h-4"/>
                            <span className="text-[#222222] text-[14px] font-light break-words text-left">{signal}</span>
                        </div>
                    </div>
                ))}
            </div>
            {/* <button 
                onClick={handleReroll}
                className="flex justify-end items-center gap-2 px-3 py-2 rounded-lg
                text-[#7A7A7A] transition-all duration-200 ml-auto text-sm"
            >
                <img src={reload} alt="reload" className="w-4 h-4"/>
                Re-roll suggestions
            </button> */}
        </div>
    )
}

export default Suggestions;